<router-outlet></router-outlet>
<app-notifications [isNotificationBarVisible]="false"></app-notifications>
